export default "__VITE_ASSET__EtWh5hpp__"